import VueRouter from 'vue-router'
import { private_routes } from './private_routes.js'
import { public_routes } from './public_routes.js'
import { 
    checkUserLogin, 
    initOrganizeMapper,
    refreshToken,
    updateLastSeen
} from './hook_function.js'
import store from '../store/index.js';

let routes = [
     ...public_routes, ...private_routes,
]

const router = new VueRouter({
    routes,
    mode: 'history'
})

router.beforeEach(async (to, from, next) => {
    console.log(to.query);
    
    // 替換瀏覽器分頁上的標題文字
    document.title = to.name + ' | Optimize99'

    store.commit('update_breadcrumbs',[])
    store.commit('setIsShowSidebar', true)

    if (to.path !== from.path) {
        store.commit('update_is_page_loading', true)
    }
    
    
    // 真的是要防奇奇怪怪的狀況ㄟ😡😡
    console.log('router.js from', from)
    console.log('router.js to', to)

    // 不需要登入後才能使用的直接放行
    if (!to.meta || to.meta.is_required_login !== true) {
        console.log('router.js', '不需要登入就可以前往的頁面')
        next()
        return
    }

    // 檢查登入狀態
    let result = await checkUserLogin() 

    // 沒過就下面一位！
    if (result === null) {
        console.log('router.js', '登入驗證沒過')
        next({ path: '/auth' });
        return
    }
    // 更新user資料
    store.commit('login', result)

    // 檢查上次操作時間是否大於expired day
    // 超過的話更新
    const expired_day = parseInt(process.env.VUE_APP_TOKEN_EXPIRED_DAY)
    const last_activate_time = store.getters.last_activate_time
    const now = new Date().getTime()
    if (last_activate_time) {
        let duration = now - parseInt(last_activate_time)
        if (duration > expired_day * 24 * 60 * 60 * 1000) {
            let new_token = await refreshToken()
            if (new_token) {
                localStorage.setItem('authorization_token', new_token)
            }
            store.commit('setLastActivateTime', now)
        }
    }
    else {
        let new_token = await refreshToken()
        if (new_token) {
            localStorage.setItem('authorization_token', new_token)
        }
        store.commit('setLastActivateTime', now)
    }

    
    let route_params = to.params

    // 如果路徑的org_id和container_id都跟原本的一樣那就不多做mapper
    // 加上不是從conrainer
    let selected_org = store.getters.selectedOrg
    let selected_container = store.getters.selectedContainer
    let now_org_id = route_params.org_id
    let now_container_id = route_params.container_id
    
    let is_change = []
    console.log('result.default_value', result)
    let tmp_result = JSON.parse(JSON.stringify(result))
    if (!tmp_result.default_value) {
        tmp_result.default_value = {}
    }
    if (now_org_id) {
        if (tmp_result.default_value.last_seen_org !== now_org_id) {
            tmp_result.default_value.last_seen_org = now_org_id
            is_change.push(true)
        }
    }

    if (now_container_id) {
        if (tmp_result.default_value.last_seen_container_id !== now_container_id) {
            tmp_result.default_value.last_seen_container_id = now_container_id
            is_change.push(true)
        }
    }

    if (is_change.length !== 0) {
        console.log('is_change',is_change)
        updateLastSeen(tmp_result.default_value)
    }



    // console.log('router.js', selected_org)
    // console.log('router.js', selected_container)
    if (selected_container) {
        if (now_org_id === selected_org.org_id && 
            now_container_id === selected_container.id && 
            from.fullPath !== '/'
        ) {
            console.log('router.js', '一樣的org和container不動')
            next()
            return
        }
    }

    console.log('router.js', '不一樣')
    
    // 過了代表真的有這個使用者，要再檢查
    // 1. 是否有歸屬在任何組織，沒有也是送去後台
    // 2. 是否有存取任一組織container的權限，沒有不能使用後台，因為都是以container的來使用的
    let organize_container_mapper = await initOrganizeMapper(result)
    if (organize_container_mapper === null) {
        next({ path: '/auth' });
        return
    }

    // 真的有這個使用者，他也至少有一個組織可以存取容器
    store.commit('update_organize_container_mapper', organize_container_mapper)

    // 假設有人亂改網址的org_id，org_id不存在的話
    // console.log('this.$route',to)

    
    // 沒選container，又在容器頁，可能是剛註冊新增完容器，預設要幫她選第一個
    if (!selected_container) {
        if (to.path.includes('/setting/containers/')) {
            console.log('現在沒有選container')
            let org_id = route_params.org_id
            if (organize_container_mapper[org_id] && organize_container_mapper[org_id]['containers'].length !== 0) {
                store.commit('select_organize', organize_container_mapper[org_id].organization)
                store.commit('selected_container', organize_container_mapper[org_id]['containers'][0])
                next()
                return
            }
        }
    }


    let org_id = route_params.org_id
    if (organize_container_mapper[org_id] === undefined) {
        console.log('router.js', '是不是有人在亂改org_id啊')
        // 第一個組織沒有容器就去容器頁la
        let first_org = organize_container_mapper[Object.keys(organize_container_mapper)[0]]
        if (first_org.containers.length === 0) {
            next({
                path: '/' +  first_org.organization.org_id + '/containers'
            })
            store.commit('select_organize', first_org.organization)
            store.commit('selected_container', null)
            
        }
        // 去第一個組織第一個容器
        else {
            next({
                path: '/' + first_org.organization.org_id + '/' + first_org.containers[0].id + '/home'
            })
            store.commit('select_organize', first_org.organization)
            store.commit('selected_container', first_org.containers[0])
        }
        return
    }

    // 假設有人亂改網址的container_id，container_id不存在的話
    let container_id = route_params.container_id
    console.log('router.js', container_id)
    if (container_id && to.path.includes('setting') === false) {
        
        let target_org = organize_container_mapper[org_id]
        let target_container = target_org.containers.filter(function(container){
            return container.id === container_id
        })
    
        if (target_container.length === 0) {
            console.log('router.js', '是不是有人在亂改container_id啊' + container_id )
            if (target_org.containers.length === 0) {
                next({
                    path: '/' +  target_org.organization.org_id + '/setting'
                })
                store.commit('select_organize', target_org.organization)
                store.commit('selected_container', null)
            }
            else {
                next({
                    path: '/' + target_org.organization.org_id + '/' + target_org.containers[0].id + '/home'
                })
                store.commit('select_organize', target_org.organization)
                store.commit('selected_container', target_org.containers[0])
            }
            return
        }
        store.commit('select_organize', target_org.organization)
        store.commit('selected_container', target_container[0])
    }


    // 假設使用者刪了自己現在選擇的container
    // if (from.fullPath === '/') {
    //     if (selected_container.id)
    // } 
    next()


    // console.log("router.beforeEach");
    // console.log(to);
    // console.log(to.path);
    // console.log(store);
    // console.log(from);
    // console.log("!!!!!!!!!!!!", to.redirectedFrom);
    // console.log(router)
    // console.log(this.$route);
    // console.log(route);

    // 從即將要進入的路由中取得 container_id
    // const TOPATH = to.path
    // const newContainerId = to.params.container_id !== undefined ? to.params.container_id : ''

    // // 檢查 container_id 是否存在且是否已改變
    // if (store.getters.selectedContainer !== null) {

        
    //     console.log(newContainerId);
    //     console.log(store.getters.selectedContainer.id);
    //     if ( to.redirectedFrom !== '/login' && newContainerId && newContainerId !== store.getters.selectedContainer.id ) {
    //         // alert("2")
    //         console.log("2");
    //         console.log("!!!!!!!!!!!!!!!!!!!!!!!!");
    //         // 如果 container_id 已改變，則調用 Vuex action 來更新它

    //         let new_path = await store.dispatch('updateContainerId', { newContainerId: String(store.getters.selectedContainer.id), route: String(TOPATH), router: router })
    //         console.log(new_path);
    //         // 替換瀏覽器分頁上的標題文字
    //         document.title = to.name + ' | Optimize99'
    //         store.commit('SET_REDIRECTED', false);
    //         next(new_path);
            
    //     } else {
        
    //         console.log(TOPATH);
        
    //         // 替換瀏覽器分頁上的標題文字
    //         document.title = to.name + ' | Optimize99'
        
    //         // 放行到下一頁
    //         // from.name === null && to.name === "行銷圖卡編輯器" && newContainerId === store.getters.selectedContainer.id ? next(TOPATH) : next()
            
    //         next()
    //     }
    // } else {
    //         console.log(TOPATH);
        
    //         // 替換瀏覽器分頁上的標題文字
    //         document.title = to.name + ' | Optimize99'
        
    //         // 放行到下一頁
    //         // from.name === null && to.name === "行銷圖卡編輯器" && newContainerId === store.getters.selectedContainer.id ? next(TOPATH) : next()
            
    //         next()
    // }

    // console.log(TOPATH);
})

router.afterEach(() => {
    // console.log('後')
    setTimeout(function(){
        // console.log('後1500')
        store.commit('update_is_page_loading', false)
        // console.log(store.is_page_loading)
    }, 500)
})

export {
    router
}